const shortenString = (string: string, length: number) => {
  if (string.length > length) {
    return string.substring(0, length) + '...'
  }
  return string
}

export default shortenString
